import { getUserId } from '@/utils/get-user-key'
import request from 'project-config/services/request/request'
import { STORAGE } from 'project-config/constants'
import { goToMainRoute } from 'project-config/utils/env'
import QRCode from 'project-config/services/qr-code'
import { saleSmartlyInstance } from 'project-config/services'

export async function toLogout() {
  const { code } = await request.post('/api/rendering/user/userLogout', {})
  const id = getUserId().toString().split('').reverse().join('')
  if (code === 200) {
    localStorage.setItem(STORAGE.PRE_USER_ID, getUserId())
    localStorage.setItem(STORAGE.USER_KEY, '')
    localStorage.setItem(STORAGE.USER_ID, '')
    localStorage.setItem(`IS_SHOW_INVITE_REGISTER_TIPS_${id}`, '')
    sessionStorage.setItem(STORAGE.HIDE_VERIFY_DIALOG, '0')
    sessionStorage.setItem(STORAGE.HIDE_STORAGE_DIALOG, '0')
    sessionStorage.removeItem(STORAGE.USER_KEY)
    QRCode.clearQRCode()
    saleSmartlyInstance.clearUserInfo()
    await request.post('/api/rendering/user/clearCookies', {
      cookieName: 'rayvision_userKey',
    })
    goToMainRoute(false)
  }
}
